// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ICustomActionSchema } from '../custom_action/CustomActionSchema';
import type { IMessageListItemV2Schema } from '../message_list_item_v2/MessageListItemV2Schema';
import type { IOfferSchema } from '../offer/OfferSchema';
import type { IChatUserSchema } from './ChatUserSchema';

export interface ISyncChatSchema {
  /** Доступные действия над чатом **/
  availableActions: EAvailableActions[];
  /** Идентификатор бота, если чат с ботом **/
  botId?: number;
  /** Идентификатор чата **/
  chatId: string;
  /** Кастомные действия для чатов **/
  customActions?: ICustomActionSchema[];
  /** Дата и время для сортировки чатов в формате ISO-8601, YYYY-MM-DDThh:mm:ss±hh **/
  datetimeForSorting: string;
  /** Описание чата. Например, '2-комн. кв. ･ 5,2 млн ₽ ･ р-н Ленинградский' **/
  description?: string;
  /** Последнее или обновленное сообщение в чате. Может отсутствовать в случае, если сообщения чата удалены **/
  lastMessage?: IMessageListItemV2Schema;
  /** Объявление по поводу которого изначально был создан чат **/
  offer?: IOfferSchema;
  /** Версия строки чата. **/
  rowVersion: number;
  /**
   *
   *     Момент времени начиная с которого можно отображать сообщения.
   *     Сообщения до этого момента времени скрыты от пользователя из-за того что чат был удалён.
   *     Если собеседник отправляет в этот чат новое сообщение, то получатель видит только сообщения после удаления.
   *     Клиенты могут опираться на это поле, чтобы удалять старые сообщения с девайсов.
   *
   */
  showMessagesFromDatetime?: string;
  /** Статус чата **/
  status: EStatus;
  /** Тип чата **/
  type: EType;
  /** Кол-во непрочитанных сообщений **/
  unreadMessagesCount: number;
  /** Участники чата **/
  users: IChatUserSchema[];
}

export enum EAvailableActions {
  /** Пользователь может переместить чат в архив **/
  'Archive' = 'archive',
  /** Пользователь может заблокировать чат (бывший спам) **/
  'Block' = 'block',
  /** Пользователь может удалить чат **/
  'Delete' = 'delete',
  /** Пользователь может разархивировать чат **/
  'Restore' = 'restore',
  /** Пользователь может отправить файлы в чат **/
  'SendFile' = 'sendFile',
  /** Пользователь может отправить сообщение в чат **/
  'SendMessage' = 'sendMessage',
  /** Пользователь может разблокировать чат (бывший спам) **/
  'Unblock' = 'unblock',
}
export enum EStatus {
  /** Чат в списке всех сообщений **/
  'Active' = 'active',
  /** Чат в архиве **/
  'Archived' = 'archived',
  /** Заблокированный чат (перемещенный в спам) **/
  'Blocked' = 'blocked',
  /** Удаленный чат **/
  'Deleted' = 'deleted',
}
export enum EType {
  /** Чат между двумя пользователями по карточке агента **/
  'Agent' = 'agent',
  /** Чат с ботом **/
  'Bot' = 'bot',
  /** Чат по новостройке **/
  'Newbuilding' = 'newbuilding',
  /** Чат между двумя пользователями по объявлению **/
  'Offer' = 'offer',
}
